import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    descText: {
        marginBottom: 20
    },
    contentContainer: {
        width: "100%",
        maxWidth: 850
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
